import { HttpContextToken } from "@angular/common/http";

/**
 * Http Context Token for Force Refresh Token
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Force Refresh Token
 * @description Http Context Token for Force Refresh Token
 * @example
 * ```typescript
 * const forceRefreshTokenContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const FORCE_REFRESH_TOKEN_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Retried After Refresh
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Retried After Refresh
 * @description Http Context Token for Retried After Refresh
 * @example
 * ```typescript
 * const retriedAfterRefreshContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const RETRIED_AFTER_REFRESH_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Bypass Error Response
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Error Response
 * @description Http Context Token for Bypass Error Response
 * @example
 * ```typescript
 * const bypassErrorResponseContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_ERROR_RESPONSE_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Bypass Error 401
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Error 401
 * @description Http Context Token for Bypass Error 401
 * @example
 * ```typescript
 * const bypassError401Context = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_ERROR_401_RESPONSE_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Bypass JWT
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass JWT
 * @description Http Context Token for Bypass JWT
 * @example
 * ```typescript
 * const bypassJwtContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_JWT_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Bypass App Request
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass App Request
 * @description Http Context Token for Bypass App Request
 * @example
 * ```typescript
 * const bypassAppRequestContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_APP_REQUEST_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Bypass Show Loading
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Show Loading
 * @description Http Context Token for Bypass Show Loading
 * @example
 * ```typescript
 * const bypassShowLoadingContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_SHOW_LOADING_CONTEXT = new HttpContextToken<boolean>(() => true);

/**
 * Http Context Token for Bypass Hide Loading
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Hide Loading
 * @description Http Context Token for Bypass Hide Loading
 * @example
 * ```typescript
 * const bypassShowLoadingContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_HIDE_LOADING_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Bypass Language
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Language
 * @description Http Context Token for Bypass Language
 * @example
 * ```typescript
 * const bypassLanguageContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_LANGUAGE_CONTEXT = new HttpContextToken<boolean>(() => false);


/**
 * Http Context Token for Bypass Session HTTP Abort
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Session HTTP Abort
 * @description Http Context Token for Bypass Session HTTP Abort
 * @example
 * ```typescript
 * const bypassSessionHttpAbortContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_SESSION_HTTP_ABORT_CONTEXT = new HttpContextToken<boolean>(() => false);